import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function FinalCTA({ onReserve }) {
  return (
    <section className="relative overflow-hidden" data-testid="final-cta">
      <span
        aria-hidden="true"
        className="font-accent pointer-events-none absolute -bottom-8 left-1/2 -translate-x-1/2 select-none whitespace-nowrap text-[24vw] italic leading-none text-white/[0.04]"
      >
        Toulouse
      </span>
      <div className="relative mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, ease: EASE }}
          className="font-display max-w-4xl text-4xl leading-tight tracking-tight text-bone sm:text-6xl lg:text-7xl"
        >
          Toulouse,{" "}
          <em className="font-accent italic text-gold">
            la nuit vous appartient.
          </em>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.15 }}
          className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400"
        >
          Le Lillet Spritz est offert le soir pour votre repas, pendant toute
          la durée du couvre-feu. Offre valable uniquement sur présentation du
          SMS — réservez dans l'une de nos cinq maisons en quelques secondes.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.25 }}
        >
          <button
            onClick={onReserve}
            data-testid="final-cta-reserve-button"
            className="mt-10 rounded-full bg-gold px-10 py-4 text-xs font-medium uppercase tracking-[0.25em] text-ink transition-colors hover:bg-champagne"
          >
            Choisir ma maison
          </button>
        </motion.div>
      </div>
    </section>
  );
}
